import React from 'react';

function Principal() {
  return (
    <section id="principal" className="principal-section">
      <div className="section-container">
        <h2 className="section-title"><span className="title-icon">👨‍🏫</span> Message from the Principal</h2>
        <div className="principal-content">
          <div className="principal-image">
            <div className="img-placeholder">👩‍⚕️</div>
            <h3>Dr. Sarah Mitchell</h3>
            <p>Principal & Dean of Academic Affairs</p>
          </div>
          <div className="principal-message">
            <blockquote>
              "Nursing is not just a profession; it is a calling to serve humanity with compassion, skill, and integrity. At Hope Nursing College, we nurture future healthcare leaders who are ready to make a difference."
            </blockquote>
            <p>Welcome to Hope Nursing College, an institution dedicated to excellence in nursing education and research. Our mission is to empower students with cutting-edge knowledge, hands-on clinical experience, and the ethical foundation required to excel in today's dynamic healthcare landscape.</p>
            <p>We believe in holistic development, fostering critical thinking, empathy, and professional competence. Our faculty, state-of-the-art facilities, and industry partnerships ensure that every graduate is job-ready and globally competitive.</p>
            <button className="btn btn-primary">Read Full Message</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Principal;